import React from 'react';

export default function AttachmentThumbnailUpload(props) {

    const {attachment}    = props

    return false;

    // *in the very beggingin (first render) dataURL is empty (!)

    const background = "url("+attachment.dropzoneFile.dataURL+")"

    return (
        <div className="thumbnail-temp-file" style={{
            backgroundImage: background
        }}></div>
    )



}